import * as React from 'react';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const OportunidadCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  transition: 'transform 0.2s, box-shadow 0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8],
  },
}));

const CardImage = styled('div')({
  width: '100%',
  height: 160,
  backgroundColor: '#f0f0f0',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: 4,
  marginBottom: 12,
});

const CardContent = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

const DEFAULT_IMAGE = 'https://lp.ondara.group/assets/img/property-default.jpg';

function getImageUrl(backendApi, dealId, imageId) {
  if (!imageId) return DEFAULT_IMAGE;
  return `${backendApi}getimage.php?module=Deals&id=${dealId}&attachment_id=${imageId}`;
}

function Oportunidades(props) {
  const navigate = useNavigate();
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);

  useEffect(() => {
    axios
      .post(props.config.backend_api + "getopportunities.php")
      .then((response) => {
        if (response.data.status === "success") {
          setOpportunities(response.data.data.opportunities);
        }
        if (response.data.status === "error") {
          setError(response.data.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError('Error al cargar las oportunidades.');
        setLoading(false);
      });
  }, [props.config.backend_api]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCardClick = (id) => {
    navigate('/opportunity/' + id, { state: { from: '/dashboard/opportunities' } });
  };

  const visibleOpportunities = opportunities.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const totalPages = Math.ceil(opportunities.length / rowsPerPage);
  const currentPage = page + 1;

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <div>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Grid container disableEqualOverflow="true" spacing={2} sx={{ mb: 2 , p: 4 }} >
        {visibleOpportunities.map((opp) => (
          <Grid key={opp.id} xs={12} md={4}>
            <OportunidadCard onClick={() => handleCardClick(opp.id)}>
              <CardImage
                style={{
                  backgroundImage: `url(${getImageUrl(props.config.backend_api, opp.id, opp.First_Image)})`,
                }}
              />
              <CardContent>
                <Typography variant="h6" component="div" sx={{ fontSize: '1rem', fontWeight: 600, mb: 0.5 }}>
                  {opp.Deal_Name || 'Sin nombre'}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  {opp.City || 'Localidad no disponible'}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Ref: {opp.Expediente || 'N/A'}
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={{ mt: 'auto' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCardClick(opp.id);
                  }}
                >
                  Más información
                </Button>
              </CardContent>
            </OportunidadCard>
          </Grid>
        ))}
      </Grid>

      {opportunities.length > rowsPerPage && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 24, gap: 16 }}>
          <IconButton
            disabled={page === 0}
            onClick={() => handleChangePage(page - 1)}
          >
            ‹
          </IconButton>
          <Typography>
            {currentPage} / {totalPages}
          </Typography>
          <IconButton
            disabled={page >= totalPages - 1}
            onClick={() => handleChangePage(page + 1)}
          >
            ›
          </IconButton>
          <Select
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
            size="small"
          >
            <MenuItem value={12}>12</MenuItem>
            <MenuItem value={24}>24</MenuItem>
            <MenuItem value={36}>36</MenuItem>
          </Select>
        </div>
      )}
    </div>
  );
}

export default Oportunidades;